// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_Ikw","cls2":"UserTaggingPingBodyStyles-cls2_-Ih UserTaggingPingBodyStyles-cls1_Ikw"};